// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chart_wrapper__3fCVk"};